module.exports = __webpack_public_path__ + "fonts/iconfont.f777ac6f.ttf";